export default __webpack_public_path__ + "static/media/Map.812ac783.png";